<template>
  <div>
    <a-row>
      <a-col :span="4">
        <a-input placeholder="请输入姓名" v-model="form.lastname" />
      </a-col>
      <a-col :span="4">
        <a-input placeholder="请输入岗位" v-model="form.jobTitleName" />
      </a-col>
      <a-col :span="4">
        <a-select
          v-model="form.sex"
          placeholder="请输入性别"
          style="width:100%"
          allowClear
        >
          <a-select-option
            v-for="(item,i) in selectArr.sexList"
            :key="i"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="12">
        <div style="width:230px">
          <a-button style="margin-left: 8px" @click="handleSync">同步</a-button>
          <a-button type="primary" style="margin-left: 8px" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
        </div>

      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      form: {
        lastname: undefined,
        jobTitleName: undefined,
        sex: undefined
      },
      selectArr: {
        sexList: [{ name: '男', id: '男' }, { name: '女', id: '女' }]
      }
    }
  },
  methods: {
    handleSync () {
      this.$emit('handleSync')
    },
    handleSearch () {
      const params = Object.keys(this.form)
        .filter((key) => this.form[key])
        .reduce((acc, key) => ({ ...acc, [key]: this.form[key] }), {})
      this.$emit('handleSearch', params)
    },
    clearSearch () {
      this.clear()
      this.handleSearch()
    },
    clear () {
      for (const key in this.form) {
        this.form[key] = undefined
      }
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/ .ant-row > div{
    height: 50px !important;
  }
  /deep/ .ant-col {
    padding-right: 10px !important;
  }
</style>
